module.exports = __webpack_public_path__ + "static/img/5878_phase_function_Paper_Points.d6bb07d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/5878_phase_function_Paper_Points.png
// module id = gU0/
// module chunks = 0